import React from 'react';
import { RANKR_STEPS } from '@/data/rankr';

export default function RankrHow() {
  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">How It Works</p>
        <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight leading-tight max-w-3xl">
          Four steps. Zero technical work for you.
        </h2>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {RANKR_STEPS.map((s, i) => (
            <div key={s.title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-7">
              <span className="font-display font-bold text-[#3B82F6] text-sm">0{i + 1}</span>
              <h3 className="mt-4 font-display font-semibold text-white text-lg">{s.title}</h3>
              <p className="mt-3 text-sm text-white/55 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}